import axios from '../../plugins/axios-common'

export default {
    namespaced: true,
    state: {
        apiUrl: '/api/cash/shift/questionare',
    },
    mutations: {},
    actions: {
        getQuestions (_, qtype) {
            console.log('type', qtype)
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: '/api/cash/shift/questionnare/' + qtype,
                }).then((resp) => {
                    resolve(resp)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        sendAnswers ({ rootState }, [type, answers]) {
            return new Promise((resolve, reject) => {
                const sendData = {
                    shiftId: rootState.shift.shift.id,
                    questionnare: answers
                }
                axios({
                    method: 'post',
                    url: '/api/cash/shift/questionnare/' + type,
                    data: sendData
                }).then((resp) => {
                    resolve(resp)
                }).catch((error) => {
                    reject(error)
                })
            })
        }
    },
    getters: {},
}
